import { render, staticRenderFns } from "./question-plain.vue?vue&type=template&id=dfd157ae&"
import script from "./question-plain.vue?vue&type=script&lang=js&"
export * from "./question-plain.vue?vue&type=script&lang=js&"
import style0 from "./question-plain.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports